import { Component, OnDestroy, OnInit } from '@angular/core';

import { ExtractionDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
    addDescriptionInput,
    addTitleInput,
    DataExtractionState,
    getExtractionDescription,
    getExtractionState,
    getExtractionTitle,
    postExtractions,
} from '@emi/shared/state/filters';

@Component({
    selector: 'via-save-and-extract',
    templateUrl: './save-and-extract.component.html',
    styleUrls: ['./save-and-extract.component.scss'],
})
export class SaveAndExtractComponent implements OnInit, OnDestroy {
    public loading: boolean;
    public title: string;
    public description: string;
    public extraction: ExtractionDto;
    public successful = false;
    private titleSubscription: Subscription;
    private descriptionSubscription: Subscription;
    private extractionSubscription: Subscription;
    public modalType = Constants.LocalStorageValues.CANCEL_MODAL;

    constructor(public readonly store: Store<DataExtractionState>) {}

    public ngOnInit() {
        this.titleSubscription = this.store.pipe(select(getExtractionTitle)).subscribe((x) => (this.title = x));
        this.descriptionSubscription = this.store.pipe(select(getExtractionDescription)).subscribe((y) => (this.description = y));
        this.extractionSubscription = this.store.pipe(select(getExtractionState)).subscribe((z) => (this.loading = z.loading));
    }

    public saveTitle(titleInput: string): void {
        this.store.dispatch(addTitleInput({ title: titleInput }));
    }

    public saveDescription(descriptionInput: string): void {
        this.store.dispatch(addDescriptionInput({ description: descriptionInput }));
    }

    public hasInvalidTitle(): boolean {
        return this.title.trim() === '';
    }

    public completeExtraction(): void {
        this.store.dispatch(postExtractions());
    }

    public ngOnDestroy(): void {
        this.titleSubscription.unsubscribe();
        this.descriptionSubscription.unsubscribe();
        this.extractionSubscription?.unsubscribe();
    }
}
